<template>
  <button
    type='button'
    class="btn customize-layout"
    :id="id"

    :class="buttonTypeClass"
  >
    <slot></slot>
  </button>
</template>

<script>

export default {
  props: {
    buttonTypeClass: {
      type: String,
      default: "btn-primary",
      required: false,
    },
    id: {
      type: String,
      default: "new-table-element",
      required: false,
    },
  },
}

</script>
